import React from 'react';
import DropdownIcon from '../../assets/dropdownIcon.svg';
import classNames from 'classnames';
import { MenuParts } from '../../constants';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import classes from './style/MenuItem.scss';
import { semanticClassNames as menuSemanticClassNames } from '../../../Menu.semanticClassNames';

export interface IMenuItemDropdownIconProps {
  chevronButtonRef: React.RefObject<HTMLButtonElement>;
  onClick: () => void;
  isOpen: boolean;
  hasSubItems: boolean;
  hasLink: boolean;
  isDropdownIconOpen: boolean;
  className?: string;
  ariaLabel?: string;
}

export const MenuItemDropdownIcon: React.FC<IMenuItemDropdownIconProps> = ({
  chevronButtonRef,
  onClick,
  isOpen,
  hasSubItems,
  hasLink,
  ariaLabel,
  isDropdownIconOpen,
  className,
}) => {
  return (
    <button
      aria-label={ariaLabel}
      ref={chevronButtonRef}
      className={classNames(
        classes.dropdownToggleButton,
        !hasSubItems && classes.noDropdownItems,
        !hasLink && classes.coverAllSpace,
        className,
      )}
      onClick={onClick}
      aria-expanded={isOpen}
      aria-haspopup="true"
    >
      <DropdownIcon
        data-part={MenuParts.DropdownIcon}
        data-open={isDropdownIconOpen ? 'true' : undefined}
        className={classNames(
          classes.dropdownIcon,
          formatClassNames(menuSemanticClassNames.itemIcon),
        )}
      />
    </button>
  );
};
